import { render, staticRenderFns } from "./RelatorioFaturasIugu.vue?vue&type=template&id=53b5b5ac"
import script from "./RelatorioFaturasIugu.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturasIugu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports